import "./style.scss";
import { AiOutlineShoppingCart } from "react-icons/ai";
import { FaRegHeart, FaSearch, FaRegUser, FaBars, FaHome } from "react-icons/fa";
import { LiaTimesSolid } from "react-icons/lia";
import { Link, useLocation, useNavigate } from "react-router-dom";
// import { Formatter } from "utils/formatter";
import "bootstrap/dist/css/bootstrap.min.css";
import { useState, useEffect, useContext } from "react";
// import DropDownCategory from "component/user/dropdownCategory";
import { getBookBySearch, getCategories } from "services/user/bookService";
import { processLogout } from "services/user/userService";
import { BiCategory, BiLogOut } from "react-icons/bi";
import logo from "../../../../assets/users/transparent.png";
import { CartContext } from "context/CartContext";
import { generateSlug } from "utils/createSlug";
import { Formatter } from "utils/formatter";
import { useRef } from "react";
import { MdHistory } from "react-icons/md";
import { PacmanLoader } from "react-spinners";

const Test = () => {
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const token = localStorage.getItem("token");
  const name = localStorage.getItem("name");
  const role = localStorage.getItem("role");
  const cartQuantity = localStorage.getItem("itemQuantityInCart");
  const [categories, setCategories] = useState([]);
  // const [cartCount, setCartCount] = useState(0);
  const navigate = useNavigate();
  const checkboxRef = useRef(null);

  const { cartCount } = useContext(CartContext);
  // const { fetchCartCount } = useContext(CartContext); 

  const [searchText, setSearchText] = useState('');
  const [searchLoading, setSearchLoading] = useState(false);
  const [showSearchResults, setShowSearchResults] = useState(false);
  const [searchBooks, setSearchBooks] = useState([])

  useEffect(() => {
    setShowSearchResults(false); 
    setSearchText('');  
  }, [location]);

  const fetchBookBySearch = async () => {
    // searchText rỗng
    if (!searchText.trim()) {
      return;
    }
    setSearchLoading(true)
    try {
      const response = await getBookBySearch(searchText.trim(), 0)
      if (response && response.data && response.data.content) {
        setSearchBooks(response.data.content);
      }
    } 
    catch (error) {
        console.log("fetchBookBySearch", error)
    }
    finally {
      setSearchLoading(false)
    }
  }

  // Kiểm tra nếu có dữ liệu tìm kiếm thì hiển thị kết quả
  useEffect(() => {
    // Kiểm tra nếu searchText có giá trị hợp lệ
    if (searchText.trim() !== '') {
      setShowSearchResults(true);
      fetchBookBySearch();  
    } 
    else {
      setShowSearchResults(false);
    }
  }, [searchText]);

  const handleSearchChange = (e) => {
      const text = e.target.value;
      setSearchText(text);
  };

  const handleKeyDownSearch = (event) => {
      if (event.key === "Enter") {
          navigate(`/books?search=${searchText.trim()}`)
      }
  }


  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await getCategories();
        setCategories(response.data);
        // await fetchCartCount();
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    fetchCategories();
  }, []);

 

  const handleLogout = async () => {
    const token = localStorage.getItem("token");
    if (token) {
      setIsLoading(true)
      try {
        await processLogout(token);
        localStorage.removeItem("token");
        localStorage.removeItem("name");
        localStorage.removeItem("role");
        localStorage.removeItem("itemQuantityInCart");
        localStorage.removeItem("expirationTime");

        navigate("/login");
      } catch (error) {
        console.error("Logout failed:", error);
      }
      finally {
        setIsLoading(false)
      }
    } else {
      console.error("No token found");
    }
  };

  const handleNavigateAndClose = (path) => {
      navigate(path);
      if (checkboxRef.current) {
          checkboxRef.current.checked = false;
      }
  };

  return (
    <>
      <div className="top">
        <div className="container">
          <div className="row">
            <div className="col-lg-2 col-md-2 col-sm-3 col-3">
              <div className="logo">
                <Link to="">
                  <img src={logo} alt="" />
                </Link>
              </div>
            </div>
            <div className="col-lg-1 col-md-1 d-none d-md-block">
              <div className="category">
                <button type="button">
                  <BiCategory />

                  <div className="submenu">
                    <ul>
                      <li>
                        <Link to={`/listing/all`}>Tất cả sản phẩm</Link>
                      </li>
                      {categories && categories.length > 0 ? (
                        categories.map((category) => (
                          <li key={category.id}>

                            <Link to={`/listing/${generateSlug(category.name)}`}>{category.name}</Link>
                           
                          </li>
                        ))
                      ) : (
                        <li>No categories available</li>
                      )}
                    </ul>
                  </div>
                </button>
              </div>
            </div>
            <div className="col-lg-6 search-container col-md-6 col-sm-7 col-7">
              <div className="search">
                <input 
                  type="text" 
                  value={searchText}
                  placeholder="Search...!!!" 
                  onChange={handleSearchChange} 
                  onKeyDown={handleKeyDownSearch}
                />
                <button type="button"
                  onClick={() => {navigate(`/books?search=${searchText}`)}}
                >
                  <FaSearch />
                </button>
                  {showSearchResults && (
                    searchBooks && searchBooks.length > 0 && searchLoading === false ? (
                      <div className="search-results">
                          {searchBooks.slice(0, 5).map(book => (
                            <>
                              <div 
                                className="row d-flex" 
                                style={{cursor: 'pointer'}}
                                onClick={() => navigate(`/details/${book.slug}`)}
                              >
                                <div className="search_img">
                                  <img className="w-100" src={book.imageLink} alt="" />
                                </div>
  
                                <div className="search_info">
                                  <h7>{book.title}</h7>
                                  <div className="d-flex justify-content-between">
                                      <span className="curPrice text-danger">{Formatter(book.discountPrice)}</span>
                                      <span className="oriPrice ms-3 me-auto">{Formatter(book.originalPrice)}</span>
                                  </div>
                                </div>
                              </div>
                              
                              <hr />
                            </>
                          ))}
                      </div>
                    ) : (
                      <>
                        <div className="search-results d-flex justify-content-center"> 
                          <PacmanLoader color="#5e2e86" />
                        </div>
                      </>
                    )
                  )}
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-2 col-2">
              <div className="header_cart">
                <ul className="ms-auto">
                  {/* <li>
                  <Link to="" className="d-none d-md-block">
                      <FaRegHeart /> <span>0</span>
                    </Link>
                  </li> */}

                  <li>
                  {cartQuantity ? (
                      <Link to="/cart-items">
                      <AiOutlineShoppingCart /> <span>{cartQuantity}</span>
                    </Link>
                    ) : (
                      <Link to="/cart-items">
                      <AiOutlineShoppingCart /> <span>{cartCount}</span>
                    </Link>
                    )}
                  </li>
                  <li className="signin d-none d-md-block">
                    {role === "user" ? (
                      <button>
                        {name}
                        {/* <FaRegUser/> */}
                        <div className="submenu">
                          <ul>
                          <li>
                            <Link to="/personal-infor">Thông tin cá nhân</Link>
                          </li>
                            <li>
                            <Link to="/order-status/all">Lịch sử mua hàng</Link>
                            </li>
                            
                            <li>
                              <a href="#" onClick={handleLogout}>
                                Đăng xuất
                              </a>
                            </li>
                          </ul>
                        </div>
                      </button>
                    ) : (
                      <Link to="/login">
                        Đăng nhập
                        {/* <FaRegUser/> */}
                      </Link>
                    )}
                  </li>

                  {/* khi thu nhỏ kích thước tầm điện thoại */}
                  <li>
                      {/* <Link to="" className="d-md-none"> */}
                      <label htmlFor="head-mobile-input" className="d-md-none">
                        <FaBars />
                      </label>
                      <input className="head-input" ref={checkboxRef} type="checkbox" id="head-mobile-input" hidden/>
                      {/* </Link> */}
                      <label htmlFor="head-mobile-input" className="head_overlay"></label>

                      {role === "user" ? (
                        <div className="head_mobile">
                          <p>{name}</p>
                          <label htmlFor="head-mobile-input" className="head-mobile_close">
                            <LiaTimesSolid/>
                          </label>

                          <hr className="hr_signin"/>

                          <ul className="user-name">
                            <li onClick={() => handleNavigateAndClose('/listing/all')}>
                                <div className="icon-mobile">
                                  <BiCategory/>
                                </div>
                                <Link>Thể loại</Link>
                            </li>

                            <li onClick={() => handleNavigateAndClose('/personal-infor')}>
                                <div className="icon-mobile">
                                  <FaRegUser/>
                                </div>
                                <Link>Thông tin cá nhân</Link>
                            </li>

                            <li onClick={() => handleNavigateAndClose('/order-status/all')}>
                                <div className="icon-mobile">
                                  <MdHistory/>
                                </div>
                                <Link>Lịch sử mua hàng</Link>
                            </li>

                          

                            <li onClick={handleLogout}>
                                <div className="icon-mobile">
                                  <BiLogOut/>
                                </div>
                                <Link>Đăng xuất</Link>
                            </li>
                          </ul>
                        </div>
                      ) : (
                        <div className="head_mobile">
                          <label htmlFor="head-mobile-input" className="head-mobile_close">
                            <LiaTimesSolid/>
                          </label>

                          <hr className="hr_no_signin"/>

                          <ul>
                            <li onClick={() => handleNavigateAndClose('/login')}>
                                <div className="icon-mobile">
                                  <FaHome/>
                                </div>
                                <Link>Đăng nhập</Link>
                            </li>

                            <li onClick={() => handleNavigateAndClose('/listing/all')}>
                                <div className="icon-mobile">
                                  <BiCategory/>
                                </div>
                                <Link>Thể loại</Link>
                            </li>
                          </ul>
                        </div>
                      )}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        {isLoading && (
            <div className="modal">
                <div className="overlay_loading">
                    <div className="modal-content_loading">
                        <div className="d-flex">
                        <PacmanLoader color="#5e2e86"/>
                        </div>
                    </div>
                </div>
            </div>
        )} 
      </div>
      {/* {
                openCategory && <DropDownCategory/>
            } */}
    </>
  );
};

export default Test;
